import { useEffect, useState } from 'react';

import * as Sentry from '@sentry/nextjs';
import type { SimilarPropertiesFragment } from '__generated__/athena/graphql';
import { GetMarketplacePropertySimilarPropertiesDocument } from '__generated__/athena/graphql';
import { getAthenaClient } from 'components/api';
import { ClientError } from 'graphql-request';

export const useSimilarProperties = (addressToken?: string) => {
  const [similarProperties, setSimilarProperties] = useState<
    SimilarPropertiesFragment | null | undefined
  >();

  useEffect(() => {
    if (!addressToken) {
      return;
    }
    const controller = new AbortController();
    const fetchSimilarProperties = async () => {
      try {
        const data = await getAthenaClient(undefined, { signal: controller.signal }).request(
          GetMarketplacePropertySimilarPropertiesDocument,
          { addressToken },
        );
        setSimilarProperties(data?.marketplace?.property?.similarProperties);
      } catch (error) {
        // Similar listings only augment the SSR-rendered page. Report only
        // server-reported failures (ClientError); a bare network-layer
        // TypeError is an expected abort (navigation or tab teardown).
        if (error instanceof ClientError) {
          Sentry.captureException(error);
        }
      }
    };
    void fetchSimilarProperties();
    return () => {
      controller.abort();
    };
  }, [addressToken]);

  return { similarProperties };
};
